<template>
  <router-view />
</template>

<script setup lang="ts">
// rien ici
</script>
